import { styled } from 'styled-components';

interface StyledInputProps {
  error?: string;
}

export const CodeInputContainer = styled.div`
  width: 100%;
  max-width: 340px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  display: inline-block;
  margin: auto;
  width: auto;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    box-shadow: 0 0 0 60px var(--pcm-body-background) inset !important;
    -webkit-text-fill-color: var(--pcm-body-color) !important;
  }
`;

export const CodeInputMask = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  cursor: pointer;
`;

export const StyleCodeInputItem = styled.input<StyledInputProps>`
  width: 42px;
  height: 42px;
  padding: 0;
  margin-right: 5px;
  margin-left: 5px;
  border: transparent;
  border-radius: var(--pcm-rounded-md);
  font-size: 20px;
  text-align: center;
  text-transform: uppercase;
  background-clip: padding-box;
  caret-color: var(--pcm-primary-color);
  color: ${({ error }) => (error ? 'var(--pcm-error-color)' : 'var(--pcm-body-color)')};
  background-color: ${({ error }) => (error ? 'var(--pcm-error-background)' : 'var(--pcm-body-background-secondary)')};

  border: none;
  &:focus,
  &:active,
  &:hover,
  &:visited,
  &:focus-visible {
    appearance: none;
    outline: none !important;
    border: none !important;
  }

  &:not(:placeholder-shown) {
    appearance: none;
    outline: 0;
  }
`;

export const FocusBorder = styled.div<{ $focusIndex: number; $showFocusBorder: boolean } & StyledInputProps>`
  position: absolute;
  top: 0;
  opacity: ${({ $showFocusBorder }) => ($showFocusBorder ? 1 : 0)};
  left: ${({ $focusIndex }) => 5 + $focusIndex * 52}px;
  width: 42px;
  height: 42px;
  border: 1px solid var(--pcm-accent-color);
  border-radius: var(--pcm-rounded-md);
  transition:
    left 0.3s ease,
    opacity 0.2s ease;
  pointer-events: none;
  z-index: 2;
`;
